import { Component, computed, inject, signal } from '@angular/core';
import { ExplainerTextComponent } from "../components/explainer-text/explainer-text.component";
import { GlossaryGroupComponent } from "./glossary-group/glossary-group.component";
import { GlossaryService } from '../services/glossary.service';
import { GlossaryTagFiltersComponent } from "./glossary-tag-filters/glossary-tag-filters.component";
import type { Tags } from '../interfaces/glossaryInterface';
import { GlossarySearchComponent } from "./glossary-search/glossary-search.component";
import { GlossaryContributorsComponent } from "./glossary-contributors/glossary-contributors.component";
import { GlossarySortingComponent } from "./glossary-sorting/glossary-sorting.component";
import { GlossaryLanguageSwitchComponent } from "./glossary-language-switch/glossary-language-switch.component";

@Component({
    selector: 'app-glossary',
    imports: [
        ExplainerTextComponent,
        GlossaryGroupComponent,
        GlossaryTagFiltersComponent,
        GlossarySearchComponent,
        GlossaryContributorsComponent,
        GlossarySortingComponent,
        GlossaryContributorsComponent,
        GlossaryLanguageSwitchComponent
    ],
    templateUrl: './glossary.component.html',
    styleUrl: './glossary.component.scss'
})
export class GlossaryComponent {
  protected tagFilters = signal<Tags>([]);
  protected query = signal<string | undefined>(undefined);
  protected primaryLanguage = signal<'en' | 'de'>('en');
  protected sortAscending = signal<boolean>(true);

  private readonly glossaryService = inject(GlossaryService);
  protected glossary = computed(() => {
    return this.glossaryService.get(
    {
      tagFilters: this.tagFilters(),
      query: this.query(),
      primaryLanguage: this.primaryLanguage(),
      sortAscending: this.sortAscending(),
    }
  )});

  protected tags = this.glossaryService.getTags();
}
